import { useListMedicalCodesByEncounter } from "@elation/api-client/src/stitch-web";
import { NUMBER_ID_NOT_READY } from "@src/utils/constants";

/**
 * Wraps the generated React Query hook with stable settings:
 *   - disabled when `encounterId` is not yet known (matches the existing
 *     `useGetEncounterById(...)` enabled-guard pattern).
 *   - relies on default React Query caching; no special staleTime tuning
 *     for the pilot.
 *
 * The query is invalidated by the encounter-events SSE channel — see
 * `useAppSSEEvents` for the existing pattern; medical-codes piggybacks
 * on the same encounter scope.
 */
export function useMedicalCodes(encounterId: number | undefined) {
  return useListMedicalCodesByEncounter(encounterId ?? NUMBER_ID_NOT_READY, {
    query: {
      enabled: typeof encounterId === "number" && encounterId > 0,
    },
  });
}
